import axios from 'axios';
import config from './config';
import Cookies from 'js-cookie';
import router from '@/router'
import {hideLoading, showLoading} from '@/utils/loading';
import {Message} from 'element-ui'

export default function $axios(options) {
    return new Promise((resolve, reject) => {
        const instance = axios.create({
            baseURL: config.baseUrl,
            headers: config.headers,
            timeout: config.timeout,
            withCredentials: config.withCredentials
        });

        instance.interceptors.request.use(
            config => {

                showLoading();
                if (Cookies.get('userInfo')) {
                    let userInfo = JSON.parse(Cookies.get('userInfo'));
                    config.headers.authorization = userInfo.token;
                } else {
                    router.push('/login')
                }
                return config
            },
            error => {
                hideLoading();
                console.log('request:', error);
                Message.error({message: '请求超时!'});
            });

        instance.interceptors.response.use(
            response => {
                hideLoading();
                let data;
                if (response.data === undefined) {
                    data = JSON.parse(response.request.responseText);
                } else {
                    data = response.data;
                }
                if (response.config.responseType === 'blob' || response.config.responseType === 'arraybuffer') {
                    let blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'}); //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
                    let downloadElement = document.createElement('a');
                    let href = window.URL.createObjectURL(blob);
                    downloadElement.href = href;

                    //获取文件名
                    let fileName = decodeURI(response.headers['content-disposition'].split("=")[1]);  //处理文件名乱码问题
                    downloadElement.download = fileName; //下载后文件名
                    document.body.appendChild(downloadElement);
                    downloadElement.click(); //点击下载
                    document.body.removeChild(downloadElement); //下载完成移除元素
                    window.URL.revokeObjectURL(href); //释放掉blob对象
                    return;
                } else {
                    if (data.code !== 0) {
                        Message.error({message: data.message});
                    } else {
                        return JSON.parse(JSON.stringify(data.data));
                    }
                }
            },
            error => {
                hideLoading();
                if (error && error.response) {
                    switch (error.response.status) {
                        case 400:
                            error.message = '请求错误';
                            break;
                        case 401:
                            error.message = '未授权，请登录';
                            break;
                        case 403:
                            error.message = '拒绝访问';
                            break;
                        case 404:
                            error.message = `请求地址出错: ${error.response.config.url}`;
                            break;
                        case 408:
                            error.message = '请求超时';
                            break;
                        case 500:
                            error.message = '服务器内部错误';
                            break;
                        case 501:
                            error.message = '服务未实现';
                            break;
                        case 502:
                            error.message = '网关错误';
                            break;
                        case 503:
                            error.message = '服务不可用';
                            break;
                        case 504:
                            error.message = '网关超时';
                            break;
                        case 505:
                            error.message = 'HTTP版本不受支持';
                            break;
                        default:
                    }
                }
                Message.error({message: error.message});
                return Promise.reject(error);
            }
        );

        instance(options).then(response => {
            if (response !== undefined) {
                resolve(response);
            }
        }).catch(error => {
            reject(error);
        })
    })
}